import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import merge from 'lodash/merge';
import enUS from '../locales/en-US/translation.json';
import enUSTactical from '../locales/en-US/tactical.json';
import { getEnvironmentType } from './contexts/useEnvType';

/**
 * Initialize i18next for entity label localization
 *
 *
 * Translations are initialized based on VITE_ENV_TYPE:
 * - h2f / il2 (gov): Base translations + tactical overrides
 * - commercial: Base translations only
 *
 * Future: Add Spanish (es-US) and other languages
 */

const { isGov } = getEnvironmentType();

i18n
  .use(initReactI18next)
  .init({
    resources: {
      'en-US': {
        translation: isGov ? merge({}, enUS, enUSTactical) : enUS,
      },
    },
    lng: 'en-US',
    fallbackLng: 'en-US',
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    react: {
      useSuspense: false, // Disable suspense mode to avoid hydration issues
    },
  });

export { i18n };
